import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import { API_BASE_URL } from "../config";

const getSoldImage = (listingId) => {
  if (!listingId) return "/images/Grass.jpg";

  if (listingId.startsWith("CLN-")) return "/images/cleaning.jpg";
  if (listingId.startsWith("POOL-")) return "/images/poolcare.jpg";

  return "/images/Grass.jpg";
};


const MySold = () => {
  const navigate = useNavigate();
  const [sold, setSold] = useState([]);
  const [loading, setLoading] = useState(true);

  const token = localStorage.getItem("token");

  useEffect(() => {
    loadSold();
  }, []);

  const loadSold = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/api/purchases/sold`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (res.data.success) {
        setSold(res.data.sold || []);
      }
    } catch (err) {
      console.error("❌ Error loading sold listings:", err);
    } finally {
      setLoading(false);
    }
  };

  const cardStyle = {
    background: "#fff",
    borderRadius: "12px",
    padding: "15px",
    border: "1px solid #ccc",
    width: "100%",
  };

  const statusColor = (status) => {
    if (status === "completed") return "#2e7d32";
    if (status === "seller_done" || status === "buyer_done") return "#fb8c00";
    if (status === "handover") return "#ffb300";
    return "#0288d1";
  };

  if (loading) return <p>Loading...</p>;

  return (
    <div style={{ maxWidth: "1200px", margin: "20px auto", padding: "10px" }}>
      <button
        onClick={() => navigate(-1)}
        style={{
          padding: "10px 16px",
          backgroundColor: "#2e7d32",
          color: "#fff",
          border: "none",
          borderRadius: "8px",
          cursor: "pointer",
          fontWeight: "bold",
          display: "inline-flex",
          alignItems: "center",
          gap: "8px",
          marginBottom: "20px",
        }}
      >
        <FaArrowLeft /> Back
      </button>

      <h2
        style={{
          color: "#2e7d32",
          textAlign: "center",
          marginBottom: "20px",
        }}
      >
        My Sold Clients
      </h2>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
          gap: "20px",
        }}
      >
        {sold.length === 0 && (
          <p style={{ textAlign: "center", width: "100%", color: "#666" }}>
            You have no sold clients yet.
          </p>
        )}

        {sold.map((p) => {
  const snapshot =
  typeof p.full_snapshot === "string"
    ? JSON.parse(p.full_snapshot)
    : p.full_snapshot;

  const suburb =
    p.suburb ||
    (snapshot?.listing?.suburb
      ? `${snapshot.listing.suburb} ${snapshot.listing.postcode || ""}`
      : "—");

  return (
    <div key={p.id} style={cardStyle}>
     <img
  src={getSoldImage(p.listingId)}
  alt="listing"
  style={{
    width: "100%",
    height: "180px",
    objectFit: "cover",
    borderRadius: "8px",
  }}
/>


      <p><strong>Listing:</strong> {p.listingId}</p>
      <p><strong>Suburb:</strong> {suburb}</p>
      <p><strong>Price:</strong> ${p.price}</p>

      <p
        style={{
          marginTop: "10px",
          color: statusColor(p.handover_status),
          fontWeight: "bold",
        }}
      >
        Status: {p.handover_status}
      </p>

      <Link to={`/listings-handover/${p.saleId}`}>

        <button
          style={{
            width: "100%",
            padding: "10px",
            backgroundColor: "#0288d1",
            color: "#fff",
            border: "none",
            borderRadius: "8px",
            marginTop: "10px",
            fontWeight: "bold",
          }}
        >
          Continue Handover
        </button>
      </Link>
    </div>
  );
})}

      </div>
    </div>
  );
};

export default MySold;
